export const life_line_coasters = {
  product_id: "10",
  grid_type: "1",
  cover_image: "/1.jpg",
  product_name: "Baum-Ringe Untersetzer-Set",
  media: ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg"],
  product_price: 29.0,
  product_slug: "life-line-coasters",
  short_description: "Das Baum-Ringe Untersetzer-Set verbindet natürliche Eleganz mit funktionaler Kunst. Gefertigt aus hochwertigem Acrylglas mit diamantgeschliffenen Rändern, schützt es Oberflächen stilvoll vor Feuchtigkeit und Flecken. Das filigrane Baumsilhouetten-Design macht es zu einem ästhetischen Highlight für jeden Wohnraum.",
  description: `
  Verschönern Sie Ihren Tisch mit der Schönheit der Natur
  <br><br>
  Wir stellen Ihnen unser exquisites „Baum-Ringe Untersetzer-Set“ vor, bei der Kunstfertigkeit auf Funktionalität trifft. Jeder Untersetzer dieser Kollektion zeigt eine sorgfältig gefertigte Baumsilhouette und ist eine künstlerische und elegante Ergänzung für Ihren Couchtisch, Essbereich oder Büroschreibtisch.
  <br><br>
  Die aus hochwertigem Acrylglas gefertigten Untersetzer sind sowohl ästhetisch ansprechend als auch langlebig und schützen Ihre Oberflächen zuverlässig vor Kondenswasser und Kleckern. Mit viel Liebe zum Detail haben wir dafür gesorgt, dass diese Untersetzer nicht nur Ihr Dekor aufwerten, sondern auch langlebig sind.
  <br><br>
  Das bezaubernde Design dieser Untersetzer passt mühelos zu einer Vielzahl von Einrichtungsstilen und macht sie zu einer anpassungsfähigen Ergänzung für Ihren Wohnraum.
  <br><br>
  Überraschen Sie Ihre Liebsten mit diesem auffälligen „Baum-Ringe Untersetzer-Set" – ein durchdachtes und künstlerisches Geschenk, das Naturliebhaber und Designkenner gleichermaßen begeistern wird. Verschönern Sie Ihr Zuhause mit der Schönheit der Natur, handwerklichem Können und einem Hauch von Eleganz.
  <br><br>
  <h6> PRODUKTPFLEGE </h6>
  Um das makellose Aussehen Ihres „Baum-Ringe Untersetzer-Set" zu erhalten, verwenden Sie ein weiches, trockenes Tuch, um Staub zu entfernen, der sich im Laufe der Zeit ansammeln kann. So sieht Ihr Neujahrsferien-Set am besten aus und behält seine transparente Brillanz.
  <br><br>
  Wenn Sie diese Pflegerichtlinien befolgen, können Sie sicherstellen, dass Ihr „Baum- Ringe Untersetzer-Set" weiterhin glänzt und Ihre Inneneinrichtung über Jahre hinweg bereichert.
  `,
  specifications: {
    rows: [
      { name: "Material", value: "Hochwertiges Acrylglas" },
      { name: "Abmessungen", value: "10cm x 10cm x 0,5cm" },
      { name: "Gewicht", value: "46 Gramm" },
      { name: "Farbe", value: "Transparent" },
      { name: "Ränder", value: "Diamantgeschliffen" },
    ],
    description: `Diese Spezifikationen unterstreichen die Premium-Qualität und Präzision Ihres „Baum-Ringe Untersetzer-Set"-Produkts und machen potenziellen Kunden deutlich, was sie in Bezug auf Material, Größe, Gewicht, Farbe und Verarbeitung erwarten können.`,
  },
  category: "Table",
  title_color: "#ffffff",
  subtitle_color: "#999999",
  price_color: "#ffffff"
};
